import React, { Component } from 'react'
import throttle from 'lodash.throttle'
import system from 'system-components'
import { themeGet } from 'styled-system'

const Progress = system(
  {
    is: 'progress',
    height: 4,
    color: 'primary.0',
    bg: 'gray.5',
    display: 'block',
    width: '100%',
  }
).extend`
  border: 0;
  z-index: 100;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &::-webkit-progress-bar { background: ${props => themeGet(`colors.${props.bg}`)}; }
  &::-webkit-progress-value { background: ${props => themeGet(`colors.${props.color}`)}; }
  &::-moz-progress-bar { background-color: ${props => themeGet(`colors.${props.color}`)}; }
`

Progress.displayName = 'Progress'

const noop = () => {}
export default class ReadingProgress extends Component {
  constructor (props) {
    super(props)

    this.targetEl = null
    this.rootEl = null
    this.max = 0
    this.viewportH = 0
    this.targetHeight = 0
    this.finishedPageRatio = props.finishedPageRatio || 0.5
    this.progressRatioCallback = props.progressRatioCallback || noop
    this.state = {
      value: 0,
    }
    this.handleResize = throttle(() => this.measure(), 25)
    this.handleScroll = throttle(() => this.update(), 25)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return (this.state.value !== nextState.value) || (this.props !== nextProps)
  }

  componentDidMount () {
    const { props } = this

    this.targetEl = props.targetEl ? document.querySelector(props.targetEl) : document.body
    this.rootEl = props.rootEl ? document.querySelector(props.rootEl) : window

    this.measure()
    this.rootEl.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount () {
    this.rootEl.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  }

  measureViewportHeight () {
    return !this.props.rootEl
      ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      : this.rootEl.clientHeight
  }

  measure () {
    this.targetHeight = this.targetEl.getBoundingClientRect().height
    this.viewportH = this.measureViewportHeight()
    this.max = this.targetHeight - this.viewportH * this.finishedPageRatio + this.targetEl.offsetTop
  }

  update = () => {
    const value = !this.props.rootEl
      ? window.pageYOffset || document.documentElement.scrollTop
      : this.rootEl.scrollTop
    this.progressRatioCallback(value/this.max)
    this.setState({
      value,
    })
  }

  render () {
    const { value } = this.state
    const {
      rootEl, targetEl, progressRatioCallback, finishedPageRatio, ...rest
    } = this.props
    return (
      <Progress {...rest} value={value} max={this.max} />
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ReadingProgress.js